<template>
  <div>
    <TitlePage :title="$t('create')+' '+$t('field')"></TitlePage>

    <v-layout wrap>

      <v-flex md3 class="pl-4 pr-4" v-if="getUser.super_admin && !this.$route.query.center_id">
        <CenterAutocomplete @message="setCenterId"></CenterAutocomplete>
      </v-flex>

      <v-flex md9 class="pl-4 pr-4">
        <SportsAutocomplete @message="setSport"></SportsAutocomplete>
      </v-flex>

      <v-flex md6 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name" @change="makeSlug" @input="makeSlug"></v-text-field>
      </v-flex>

      <v-flex md6 class="pl-4 pr-4">
        <v-text-field :label="$t('slug')" v-model="item.slug" :rules="validation.textRules" :error-messages="errors.slug"></v-text-field>
      </v-flex>

      <v-flex md12 class="pl-4 pr-4">
        <FeaturesAutocomplete @message="setFeatures"></FeaturesAutocomplete>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-file-input counter show-size truncate-length="15" :label="$t('uploadImage')" v-model="item.file"></v-file-input>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-switch v-model="item.active" inset :label="$t('status')" dense hide-details></v-switch>
      </v-flex>

      <v-flex md12 class="d-flex">
        <v-chip color="primary" label small text-color="white">{{$t('note')}}</v-chip>
      </v-flex>

      <v-flex md12 class="pa-4">
        <CKEditor v-if="this.item.note != null" :content="item.note" @message="(data) => item.note = data"></CKEditor>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="secondary" class="ml-auto" @click="save(false)" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-2" @click="save(true)" type="submit">
          {{ $t('saveAndCreateNew') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-2" @click="save('settings')" type="submit">
          {{ $t('saveAndSettings') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import SportsAutocomplete from "@/components/admin/SportsAutocomplete";
import FeaturesAutocomplete from "@/components/admin/FeaturesAutocomplete";
const slugify = require('slugify')
import CKEditor from "@/components/admin/CKEditor";

export default {
  name: "CreateField",
  components: {CenterAutocomplete, TitlePage, SportsAutocomplete, FeaturesAutocomplete, CKEditor},
  data() {
    return {
      item: {
        name: '',
        slug: '',
        center_id: null,
        sports: [],
        features:[],
        active: false,
        image: "",
        file: null,
        note: "",
        master_calendar : [
          [], [], [], [], [], [], []
        ],
        master_calendar_enabled: true
      },
      check: true,
      errors:{
        name: '',
        slug: '',
        center_id: '',
        sport_id: '',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ],
      }
    };
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser':'user/getUser'
    }),
  },
  async created(){
    if(this.$route.query.center_id){
      this.item.center_id = this.$route.query.center_id
    }

    if(!this.getUser.super_admin){
      this.item.center_id = this.getUser.center_id
    }
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'storeItem': 'fields/store'
    }),
    async save(redirect){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }


      await this.setLoading(true);
      var result = await this.storeItem(this.item)
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        if(!redirect){
          await this.$router.push('/fields/')
        }else if(redirect == 'settings'){
          await this.$router.push(`/fields/settings/${result.result.result._id}`)
        }else if(redirect){
          await this.$router.go()
        }

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

      if(!this.item.slug){
        this.check = false
        this.errors.slug = this.$t('fillMandatory');
      }

      if(this.item.sports.length == 0){
        this.check = false
        this.errors.sport_id = this.$t('fillMandatory');
      }

    },


    async setCenterId(id){
      this.item.center_id = id
    },

    async setSport(sport){
      this.item.sports = []
      sport.map((x) =>{
        this.item.sports.push(x._id)
      })
    },

    async setFeatures(data){
      this.item.features = []
      data.map((x) =>{
        this.item.features.push(x._id)
      })
    },

    async makeSlug(){
      this.item.slug = slugify(this.item.name, {remove: /[*+~.()'"!:@,/]/g,lower: true, locale: 'it'})
    },

    async resetError(){
      this.errors = {
        name: '',
        slug: '',
        center_id: '',
        sport_id: '',
      }
    },

  },
  mounted() {

  },
}
</script>

<style>
</style>